import { useQuery } from '@tanstack/react-query';
import { fetchFromApi } from '../apiClient';
import {
  LocationTransaction,
  ProcessTransaction,
} from 'types/dashboardTypes';

// Base API URL
const REACT_APP_DARWIN_URL = import.meta.env.VITE_DARWIN_URL;

// Query keys
const DASHBOARD_QUERY_KEY = 'dashboard';
const LOCATION_TRANSACTIONS_QUERY_KEY = 'location-transactions';
const PROCESS_TRANSACTIONS_QUERY_KEY = 'process-transactions';

/**
 * Fetch location transactions for dashboard
 */
export const useGetLocationTransactions = (companyId: string) => {
  return useQuery({
    queryKey: [DASHBOARD_QUERY_KEY, LOCATION_TRANSACTIONS_QUERY_KEY, companyId],
    queryFn: () =>
      fetchFromApi<LocationTransaction[]>(
        `${REACT_APP_DARWIN_URL}/dashboard/${companyId}/location-transactions`
      ),
    enabled: !!companyId,
    refetchOnWindowFocus: false,
  });
};

/**
 * Fetch process transactions for dashboard
 */
export const useGetProcessTransactions = (companyId: string) => {
  return useQuery({
    queryKey: [DASHBOARD_QUERY_KEY, PROCESS_TRANSACTIONS_QUERY_KEY, companyId],
    queryFn: () =>
      fetchFromApi<ProcessTransaction[]>(
        `${REACT_APP_DARWIN_URL}/dashboard/${companyId}/process-transactions`
      ),
    enabled: !!companyId,
    refetchOnWindowFocus: false,
  });
};

